/**
 * Parse Google JWT ID Token payload (without external libraries)
 * @param {string} token - Google ID token JWT
 * @returns {object|null}
 */
export const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window.atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Error parsing JWT:', e);
    return null;
  }
};

/**
 * Dynamically load Google Identity Services GSI client script
 * @param {function} callback - Callback function triggered once loaded
 */
export const loadGoogleScript = (callback) => {
  const existingScript = document.getElementById('google-gsi-client');
  if (existingScript) {
    if (window.google?.accounts?.id && callback) {
      callback();
    }
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://accounts.google.com/gsi/client';
  script.id = 'google-gsi-client';
  script.async = true;
  script.defer = true;
  script.onload = () => {
    if (callback) callback();
  };
  script.onerror = (err) => {
    console.error('Failed to load Google Identity Services script:', err);
  };
  document.head.appendChild(script);
};
